module.exports = __webpack_public_path__ + "static/img/4769_phase_function_Paper_Points.c09ad91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4769_phase_function_Paper_Points.png
// module id = IB1S
// module chunks = 0